<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <!-- Per Page + Total -->
        <div
          class="col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label class="me-2">Voir</label>
          <v-select
            v-model="users1.per_page"
            :options="[10, 25]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-2"
            @input="getData"
          />
          <label>sur {{ users1.total }} entité</label>
        </div>

        <!-- Search -->
        <div class="col-16 col-md-6">
          <div class="custom-search d-flex justify-content-end">
            <div class="d-flex align-items-center">
              <label class="me-2">Chercher</label>
              <input
                v-model="users1.searchTerm"
                type="text"
                class="form-control d-inline-block"
                placeholder="chercher"
                @change="getData"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <vue-good-table :columns="columns" :rows="ExportToday" :rtl="dir">
        <template #table-row="props">
          <span v-if="props.column.field === 'num'" class="text-nowrap">
            {{ props.row.originalIndex + 1 }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>

      <!-- Pagination -->
      <div class="row mt-2">
        <div class="col-12 col-md-6"></div>
        <div class="col-12 col-md-6 d-flex justify-content-end">
          <PaginatorContent
            :pagination="users1"
            :offset="9"
            @paginate="getData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import api from "@/utils/axios";

interface UserPagination {
  searchTerm: string;
  total: number;
  per_page: number;
  from: number;
  to: number;
  current_page: number;
}

const dir = ref(false);
const ExportToday = ref<any[]>([]);

const columns = [
  { label: "N°", field: "num" },
  { label: "Code denvoi", field: "code" },
  { label: "Nom du magasin", field: "store" },
  { label: "Téléphone", field: "phone" },
  { label: "Ville", field: "city_name" },
  { label: "Destinataire", field: "receiver" },
  { label: "Crbt", field: "price" },
  { label: "Zone", field: "zone_name" },
];

const users1 = ref<UserPagination>({
  searchTerm: "",
  total: 0,
  per_page: 10,
  from: 1,
  to: 0,
  current_page: 1,
});

const getData = async (page = 1) => {
  try {
    users1.value.current_page = page;
    const res = await api.get(`/api/auth/ExportTodayReported`, {
      params: {
        searchTerm: users1.value.searchTerm,
        page: users1.value.current_page,
        per_page: users1.value.per_page,
      },
    });
    ExportToday.value = res.data.users.data;
    users1.value = res.data.users;
  } catch (e) {
    console.error(e);
  }
};

onMounted(getData);
</script>
